import { USERS_RESPONSE, USERS_LOAD, UPDATE_UNIQUE_USER } from '../actions/types';

const INITIAL_STATE = {
    loading_users: false,
    msg_users: '',
    paginate: {
        data: [],
        lastPage: 2,
        page: 1,
        perPage: 20,
        total: 0,
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USERS_LOAD:
            return { ...state, loading_users: action.load }
        case USERS_RESPONSE:
            return { ...state, ...action.payload }
        case UPDATE_UNIQUE_USER:
            var paginate = state.paginate
            paginate.data = paginate.data.map( user => {
                if(user.cpfcnpj === action.user.cpfcnpj) user = action.user
                return user
            })
            return { ...state, paginate }
        default:
            return state
    }
};